import Carousel from '../lib/Carousel.js';

export default {
    dependencies: ['$element', 'swipeservice', 'radio', 'videoservice'],
    callable(ele, swipeService, radio, videoservice) {
        const carousel = new Carousel(
            ele.querySelector('[data-carousel-container]'),
            navigationHandler
        );
        carousel.preload(1); // preload one before and one after
        const prevButtonEle = ele.querySelector('[data-prev]');
        const nextButtonEle = ele.querySelector('[data-next]');
        prevButtonEle.addEventListener('click', event => {
            event.stopPropagation();
            carousel.previous();
        });
        nextButtonEle.addEventListener('click', event => {
            event.stopPropagation();
            carousel.next();
        });
        document.body.addEventListener('keydown', handleKeydown);

        swipeService.addListeners(ele);
        ele.addEventListener('swiperight', () => carousel.previous());
        ele.addEventListener('swipeleft', () => carousel.next());

        const swipeDiv = ele.querySelector('[data-video-swipe]');
        if (swipeDiv) {
            swipeDiv.addEventListener('click', e => {
                e.stopPropagation();
                videoservice.playVideo(carousel.currentEle);
                e.target.remove();
            });
        }

        function handleKeydown(event) {
            if (event.target.closest('input, textarea')) {
                return;
            }

            if (
                event.metaKey ||
                event.altKey ||
                event.shiftKey ||
                event.ctrlKey
            ) {
                return;
            }

            switch (event.keyCode) {
                case 37: // Left arrow
                    prevButtonEle.click();
                    event.preventDefault();
                    break;

                case 39: // Right arrow
                    nextButtonEle.click();
                    event.preventDefault();
                    break;
            }
        }

        function navigationHandler(index, ele, count) {
            videoservice.stopVideo(carousel.currentEle);
            radio('main-image-carousel-navigate').broadcast(index, ele, count);
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/mainImageCarousel.js